var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":[10, 20, 50, 100, 200, 500, 1000],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalSize},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }